import { render, staticRenderFns } from "./GridOrdersEvent.vue?vue&type=template&id=20d16378&"
import script from "./GridOrdersEvent.vue?vue&type=script&lang=js&"
export * from "./GridOrdersEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20d16378')) {
      api.createRecord('20d16378', component.options)
    } else {
      api.reload('20d16378', component.options)
    }
    module.hot.accept("./GridOrdersEvent.vue?vue&type=template&id=20d16378&", function () {
      api.rerender('20d16378', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ordersEvent/grid/GridOrdersEvent.vue"
export default component.exports